import { render, staticRenderFns } from "./TechComments.vue?vue&type=template&id=0e518c68&scoped=true&"
import script from "./TechComments.vue?vue&type=script&lang=js&"
export * from "./TechComments.vue?vue&type=script&lang=js&"
import style0 from "./TechComments.vue?vue&type=style&index=0&id=0e518c68&lang=scss&scoped=true&"
import style1 from "./TechComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e518c68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e518c68')) {
      api.createRecord('0e518c68', component.options)
    } else {
      api.reload('0e518c68', component.options)
    }
    module.hot.accept("./TechComments.vue?vue&type=template&id=0e518c68&scoped=true&", function () {
      api.rerender('0e518c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/TechComments.vue"
export default component.exports